<div class="image" [background]="picture">
	@if (!present) {
		<i class="fa fa-ban"></i>
	}
</div>

<i class="fa fa-angle-right"></i>

<h2>
	<span [innerHTML]="name"></span>
	@if (showActiveDarItemsIcon && openObservations()) {
		<mark class="content-box">
			<i class="fa fa-eye" data-test="active-observations-eye-icon"></i>
		</mark>
	}
</h2>
